<template>
    <div class="col mx-2">
        <div class="card bg-warning">
            <div class="card-body text-white pb-0">
                <div class="d-flex justify-content-between align-items-center">
                    <p class="display-3 mb-0">
                        <i class="fas fas fa-sync-alt"></i>
                    </p>
                    <p class="display-4 mb-0">{{ n }}</p>
                </div>
                <h4 class="text-right">Retornos</h4>
            </div>
            <div class="card-footer text-right">
                <slot name='router'/>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: ['id', 'n']
};
</script>
